"use client";;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:ENCON_SENTRY_KEY":true});}catch(e){}}();

import { useTranslations } from "next-intl";
import type { ChangeEvent } from "react";
import { type Locale, visibleLocales } from "@/i18n/routing";
import { useLocale } from "@/providers/LocaleProvider/index.client";
import "./locale-switcher-inline.scss";

export default function LocaleSwitcherInline() {
	const t = useTranslations("LocaleSwitcher");
	const { locale: defaultValue, onLocaleSelect } = useLocale();

	function onValueChange(event: ChangeEvent<HTMLInputElement>) {
		const nextLocale = event.target.value as Locale;
		onLocaleSelect(nextLocale);
	}

	return (
		<div className="locale-switcher-inline">
			<p className="sr-only">{t("locale", { locale: defaultValue })}</p>
			{visibleLocales.map((cur) => (
				<label
					key={cur}
					className={`locale-switcher-inline__label ${cur === defaultValue ? " active" : ""}`}
				>
					<input
						type="radio"
						className="locale-switcher-inline__input"
						name="locale"
						value={cur}
						defaultChecked={cur === defaultValue}
						onChange={onValueChange}
					/>
					<span className="locale-switcher-inline__text">
						{t("locale", { locale: cur })}
					</span>
				</label>
			))}
		</div>
	);
}
